import { configure, defineRule, Field, Form } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import * as rules from "@vee-validate/rules";
import ValidationObserver from "@/components/organisms/validation/ValidationObserver.vue";
import ValidationProvider from "@/components/organisms/validation/ValidationProvider.vue";
import CustomValidationObserver from "@/plugins/CustomValidationObserver.vue";
import {
  phoneNumberWithSpaceRule,
  phoneNumberToReceiveSMSRule,
  requiredAllowFalse
} from "./rules";

Object.entries(rules).forEach(([id, validator]) => {
  // @ts-ignore
  defineRule(id, validator);
});

defineRule("strict_password", (value: string) => {
  const hankakuNumber = /[0-9]/;
  const hankakuEnglish = /[a-zA-Z]/;
  const hankakuSymbol = /[!-/:-@[-`{-~]/;
  return (
    hankakuNumber.test(value) &&
    hankakuEnglish.test(value) &&
    hankakuSymbol.test(value)
  );
});

// 半角英字が含まれているか
defineRule(
  "include_hankaku_english",
  (value: string): boolean => !!value.match(/[a-zA-Z]/)
);
// 半角数字が含まれているか
defineRule(
  "include_hankaku_number",
  (value: string): boolean => !!value.match(/[0-9]/)
);

defineRule("hankaku_kana", (value: string) => !!value.match(/^[ｦ-ﾟ]*$/));

defineRule("min_account_number", rules.min);

defineRule("at_latest_one", (_: boolean, list: boolean[]) =>
  list.includes(true)
);

defineRule("phonenumber_to_receive_sms", phoneNumberToReceiveSMSRule.validate);
defineRule("phonenumber_with_space", phoneNumberWithSpaceRule.validate);

defineRule("required_allow_false", requiredAllowFalse);

configure({
  /* eslint-disable @typescript-eslint/naming-convention */
  generateMessage: localize("ja", {
    ...ja,
    messages: {
      ...ja.messages,
      // デフォルトだとエラーメッセージが、"メールアドレスは有効なメールアドレスではありません"
      // という不自然なものになるので、emailエラーメッセージを更新
      email: "メールアドレスが正しく入力できているかご確認ください",
      strict_password:
        "パスワードは半角の英字、数字、記号を少なくとも一つずつ使用して入力してください",
      include_hankaku_english: "半角英字を使用して入力してください",
      include_hankaku_number: "半角数字を使用して入力してください",
      hankaku_kana: "半角カナを使用して入力してください",
      min_account_number: "先頭に0をつけて7桁にしてください",
      at_latest_one: "いずれか一つ以上を選択してください",
      phonenumber_to_receive_sms: phoneNumberToReceiveSMSRule.message,
      phonenumber_with_space: phoneNumberWithSpaceRule.message,
      required_allow_false: ja.messages.required
    }
  }),
  /* eslint-enable */
  validateOnBlur: true
});
setLocale("ja");

export {
  ValidationObserver,
  ValidationProvider,
  CustomValidationObserver,
  Field as ValidationField,
  Form as ValidationForm
};
